import * as React from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { NavMenuOption, PageLayout } from "../../../components/PageLayout/PageLayout";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { BreadcrumbItem } from "../../../components/Breadcrumbs/Breadcrumbs";
import { MtUsageForClientBillingAnalyticsTab } from "./MtUsageForClientBillingAnalyticsTab";
import { MtUsageForClientBillingReportsTab } from "./MtUsageForClientBillingReportsTab";

const breadcrumbs: BreadcrumbItem[] = [
  {
    path: "/analytics",
    label: "Analytics"
  },
  {
    path: "/analytics/mtUsageForClientBilling",
    label: "MT Usage for Client Billing",
    active: true
  }
];

const MtUsageForClientBillingAnalyticsPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const reportMatch = useRouteMatch<{ reportId: string }>("/analytics/mtUsageForClientBilling/reports/:reportId");
  const isReportsRoute = location.pathname.startsWith("/analytics/mtUsageForClientBilling/reports");
  const tabIndex = isReportsRoute ? 1 : 0;

  const handleTabChange = React.useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      history.push(
        newValue === 0 ? "/analytics/mtUsageForClientBilling/analytics" : "/analytics/mtUsageForClientBilling/reports"
      );
    },
    [history]
  );

  return (
    <PageLayout
      selectedNavMenu={NavMenuOption.ANALYTICS}
      title={
        <Typography variant="h6" sx={{ mb: 2 }}>
          MT Usage for Client Billing
        </Typography>
      }
      breadcrumbs={breadcrumbs}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="Usage Analytics" />
          <Tab label="Usage By Billing Type Reports" />
        </Tabs>
      </Box>

      {tabIndex === 0 && <MtUsageForClientBillingAnalyticsTab />}
      {tabIndex === 1 && <MtUsageForClientBillingReportsTab reportId={reportMatch?.params.reportId} />}
    </PageLayout>
  );
};

export { MtUsageForClientBillingAnalyticsPage };
